import { Switch, FormControlLabel } from "@mui/material";
import { auth, db } from "../../../firebaseConfig.js";
import PropTypes from "prop-types";
import { doc, getDoc, updateDoc } from "firebase/firestore";

const ThemeToggle = ({ colorMode, setColorMode }) => {
  const handleThemeChange = (event) => {
    const newIsDarkMode = event.target.checked;
    setColorMode(newIsDarkMode ? "dark" : "light");
    if (!auth.currentUser) return;
    const docRef = doc(db, "users", auth.currentUser.uid);
    getDoc(docRef).then((docSnap) => {
      if (docSnap.exists()) {
        updateDoc(docRef, { colorMode: newIsDarkMode ? "dark" : "light" });
      }
    });
  };

  return (
    <FormControlLabel
      control={<Switch checked={colorMode === "dark"} onChange={handleThemeChange} />}
      label={<span style={{ color: "var(--Grey7)" }}>{colorMode === "dark" ? "Dark Mode" : "Light Mode"}</span>}
    />
  );
};

ThemeToggle.propTypes = {
  colorMode: PropTypes.string.isRequired,
  setColorMode: PropTypes.func.isRequired,
};

export default ThemeToggle;
